// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2gimw","col":"styles_col__I8RE0"};